export default __webpack_public_path__ + "static/media/map.847bbe50.png";